import React from 'react'
import Grid from '@blocks/Grid'
import SalonGallerySection from './components/SalonGallerySection'
import { useSalonGalleryContext } from '../../context'

export default function SalonGallerySections() {
    const { gallery } = useSalonGalleryContext()

    if (!gallery.data)
        return null

    return (
        <Grid gap="60px">
            {gallery.data.map((section, idx) => <SalonGallerySection key={idx} last={idx + 1 === gallery.data!.length} {...section} />)}
        </Grid>
    )
}